class ApiMethod {
  eventMap: Map<string, any>;
  callbackMap: Map<any, any>;
  constructor() {
    this.eventMap = new Map();
    this.callbackMap = new Map();
  }

  /**
   * 根据API名称添加回调
   * @param {String} apiName
   * @param {Function} handles
   */
  on(apiName: string, handles: Function) {
    const callback = function (...args: any[]) {
      try {
        handles.apply(undefined, args);
      } catch (error) {
        console.error(error);
      }
    };
    this.callbackMap.set(handles, callback);
    if (this.eventMap.has(apiName)) {
      this.eventMap.get(apiName)?.add(callback);
    } else {
      this.eventMap.set(apiName, new Set([callback]));
    }
  }

  /**
   * 根据API名称和handles，删除对应的回调
   * @param {String} apiName
   * @param {Function} handles
   */
  off(apiName: string, handles?: Function) {
    const apiEvent = this.eventMap.get(apiName);
    if (apiEvent) {
      if (!handles) {
        apiEvent.clear();
      } else {
        const callback = this.callbackMap.get(handles);
        apiEvent.delete(callback);
      }
    }
  }

  /**
   * 根据API名称获取回调列表
   * @param {String} apiName
   * @returns
   */
  get(apiName: string) {
    return this.eventMap.get(apiName);
  }

  /**
   * 根据API名称执行全部的相关回调
   * @param {String} apiName
   * @param {Object} params
   */
  emit(apiName: string, params: any) {
    const apiEvent = this.eventMap.get(apiName);
    if (apiEvent) {
      for (const callback of apiEvent) {
        callback.call(this, params);
      }
    }
  }
}

const apiMethod = new ApiMethod();
export { apiMethod };
